/*

  u t i l s
  Utils

  :description:
  General utility functions.

*/

export const talk = (level, group, message) => {
  if(!level){
    level = "log"
  }
  console[level](group, message)
}


export const renderMessage = (group, messageId, message) => {
  return `[${group}-${messageId}] ${message}`
}

export const isTruthy = (value, noIsTruthy) => {
  if (typeof value === 'undefined') { return false; }
  if (value === undefined || value === null) { return false; }
  if (value === '') { return false; }
  if (value === 0) { return false; }
  if (value === 0.0) { return false; }
  if (typeof value === "object") { if (Object.keys(value).length === 0) { return false } }
  if (value === false) { return false }
  if (value === "false") { return false }
  if (typeof value === "string") { if (value.length === 0) { return false; } }
  if (value === "no" && !noIsTruthy) { return false }
  if (value === "null") { return false }
  if (value === "undefined") { return false }
  if (value === null) { return false }
  return true;
}